var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteChecmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-197 -1626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0A12.5,12.5,0,1,1,0,12.5,12.5,12.5,0,0,1,12.5,0Z",
    transform: "translate(197 1626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.883 1628.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20.234V20.234H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.123,14.51,4.607,10.994l-1.2,1.189L8.123,16.9,18.24,6.779,17.051,5.59Z",
    transform: "translate(-0.535 -0.877)",
    fill: "#86529a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteChecmark);
export default __webpack_public_path__ + "static/media/white-checmark.58034b39c2709dc80c85e3d9a0975a42.svg";
export { ForwardRef as ReactComponent };